import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { ambiente_produccion, produccion } from '../../utils/Datos';
import logoCu from '../../assets/logos/logo-claveunica.svg';

export const ClaveUnica = () => {

    const {rut,id_precalifiacion,acuerdo} = useParams();
    
    const control = ambiente_produccion ? 'https://calificaciones.penalolen.cl/successCu' : 'https://calificacionesdev.penalolen.cl/successCu';
    //const control = 'http://localhost:3001/successCu';
    const form = useRef(null);
    
    const handleCu=()=>{
        form.current.submit();
    }
    return (
        <div className='col-md-12'>
            <div className='row'>
                <div className='col-md-12 pl-2'>
                    <div className='card'>
                        <div className='card-body'>
                            <h3 className='mb-5'>CLAVE UNICA REGISTRO CIVIL</h3>
                            <div className="alert alert-primary" role="alert">
                                <p>Para continuar con la validación de tu evaluación, debes iniciar sesión con tu clave única:</p>
                                <img 
                                className='mb-3'
                                src={logoCu} width={200} onClick={handleCu} style={{cursor:'pointer'}}></img>
                                <br/>
                                <small className='mt-2'>Para cancelar este paso solo cierra esta ventana.</small>
                            </div>
                            <form 
                            ref={form}
                            action="https://claveunica.penalolen.cl/LoginCU/SolicitudCU" method="post">
                                <input name="app" value="Calificaciones" type='hidden'></input>
                                <input name="param" value={rut+';'+id_precalifiacion+";"+acuerdo} type='hidden'></input>
                                <input name="control" value={control} type='hidden'></input>
                                <input name="metodo" value="get" type='hidden'></input>
                        
                            </form>
                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
